import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import {
  ButtonWrapper,
} from '../../components';

const ServerError = () => {
  const { t } = useTranslation();

  return (
    <Container>
      <Helmet>
        <title>{t('pages.500.title')}</title>
      </Helmet>
      <div className="row">
        <div className="col-12 col-md-10 offset-md-1">
          <div className="ServerError">
            <h1>{t('pages.500.title')}</h1>
            <p>{t('pages.500.body', { pagename: typeof window !== 'undefined' && window.location.href })}</p>
            <div className="Buttonwrapper">
              <ButtonWrapper href={t('pages.500.primary_button.url')}>
                {t('pages.500.primary_button.link')}
              </ButtonWrapper>
              <ButtonWrapper type="secondary" href={t('pages.500.secondary_button.url')}>
                {t('pages.500.secondary_button.link')}
              </ButtonWrapper>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default ServerError;
